import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { AssignedPermissionSets } from '../store/assigned-permissionsets/assigned-permissionsets.state'
import { eps } from './url.service'

@Injectable({
  providedIn: 'root'
})
export class AssignedPermissionSetsService {
  private apiUrl = eps.permissionSet.permissionSetApi

  constructor(private http: HttpClient) {}

  // getAssignedPermissionSets(
  //   params?: string | null,
  //   page?: number,
  //   limit?: number
  // ): Observable<any> {
  //   const url = params
  //     ? `${this.apiUrl}?${params}&page=${page}&limit=${limit}`
  //     : `${this.apiUrl}?page=${page}&limit=${limit}`
  //   return this.http.get<any>(url)
  // }

  getAssignedPermissionSets(
    employeeId: string,
    params?: string | null,
    page?: number,
    limit?: number
  ): Observable<any> {
    // Build query params
    // const queryParams = `${params}&page=${page ?? 1}&limit=${limit ?? 10}`
    const queryParams = params
      ? `${params}&page=${page ?? 1}&limit=${limit ?? 10}`
      : `page=${page ?? 1}&limit=${limit ?? 10}`

    // Construct URL using employeeId in the path
    const url = `${this.apiUrl}/user/assigned/${encodeURIComponent(employeeId)}?${queryParams}`

    return this.http.get<any>(url)
  }

  createAssignedPermissionSets(assignedPermissionSets: {
    validUpto?: string
    permissionSetIds: string[]
    userId: string
  }): Observable<AssignedPermissionSets[]> {
    return this.http.post<AssignedPermissionSets[]>(
      `${this.apiUrl}/user/assignedTo`,
      assignedPermissionSets
    )
  }

  updateAssignedPermissionSets(assignedPermissionSets: {
    id: string
    validUpto: string
    userRoleId: number
    userId: string
  }): Observable<AssignedPermissionSets> {
    return this.http.put<AssignedPermissionSets>(
      `${this.apiUrl}/${assignedPermissionSets.id}`,
      assignedPermissionSets
    )
  }

  getAllPermissionSets(businessId?: string, page?: number, limit?: number): Observable<any> {
    const params = new URLSearchParams()
    if (businessId) params.set('businessId', businessId)
    if (page) params.set('page', String(page))
    if (limit) params.set('limit', String(limit))
    const query = params.toString()
    const url = query ? `${this.apiUrl}?${query}` : this.apiUrl
    return this.http.get<any>(url)
  }
}
